import React from 'react'

import {Helmet} from "react-helmet";

import PageAnalytics from '../../components/PageAnalytics'

// SECTIONS
import SectionHome from './SectionAbout'

const Page = (props) => {
  return (
    <div>

      {/* Html header */}
      <Helmet>
        <title>About</title>
      </Helmet>

      {/* Analytics */}
      <PageAnalytics title='About'/>

      <SectionHome />
    </div>
  )
}


export default Page




// WEBPACK FOOTER //
// ./src/pages/About/index.js